import { Menu } from "@/services/manageService/menuService";
import Dept from "@/components/manage/sys/dept";
import User from "@/components/manage/sys/user";
import MenuComp from '@/components/manage/sys/menu';
import Role from "@/components/manage/sys/role";
import Company from "@/components/company-info/company";
import GlCategory from "@/components/manage/category";
import CompanyAnnual from "@/components/company-info/company-annual";
import companyFsCategory from "@/components/manage/category/co-fs-cate";
import companyGlCategory from "@/components/manage/category/co-gl-cate";
import adjustment from "@/components/audit/adjustment";
import financeStatement from "@/components/audit/finance-statement";
import GlInvoice from "@/components/account/gl-invoice";
import SmeFrs from "@/components/manage/dictionary/sme-frs";
import WokeDone from "@/components/manage/dictionary/objectives";
import Bank from "@/components/manage/dictionary/bank";
import AuditCertificate from "@/components/manage/other/audit-certificate";
import TaxRep from "@/components/manage/other/tax-rep";
import ServiceMonitor from "@/components/manage/sys/monitor/ServiceMonitor";
import OcrConfig from "@/components/manage/sys/ocr";
import OperationLog from "@/components/manage/sys/operation-log";
import GovC7 from "@/components/manage/gov/c7";
import GovProgramTemplate from "@/components/manage/gov/program-template";
import GovIrdRate from "@/components/manage/gov/ird-rate";
import ToolsCurrencyRate from "@/components/tools/currency-rate";

/** Normalize one path segment to kebab-case. */
const normalizeSegment = (segment: string) =>
    segment
        .replace(/_/g, '-')
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
        .toLowerCase();

/**
 * Full realm_url -> react-admin Resource name (no leading slash).
 * e.g. /company-info/company -> company-info/company
 */
export const toRealmResourceName = (realmUrl?: string, fallbackRealm?: string, menuId?: number) => {
    const raw = (realmUrl || fallbackRealm || '').toString().trim();
    const cleaned = raw
        .replace(/^\/+/, '')
        .split('/')
        .filter(Boolean)
        .map(normalizeSegment)
        .join('/');
    if (cleaned) return cleaned;
    return menuId != null ? `menu-${menuId}` : '';
};

/** Browser path aligned with realm_url, e.g. /audit/schedule */
export const toRealmRoutePath = (realmUrl?: string, fallbackRealm?: string, menuId?: number) => {
    const name = toRealmResourceName(realmUrl, fallbackRealm, menuId);
    return name ? `/${name}` : '/';
};

/** Last path segment only; used to map menu -> page component. */
export const getRealmKey = (realm?: string) => {
    if (!realm) return '';
    const cleaned = realm.toString().trim().replace(/^\/+?/i, '');
    const parts = cleaned.split('/').filter(Boolean);
    return normalizeSegment(parts[parts.length - 1] || '');
};

// 自动补全菜单节点的 list 组件
export function attachComponent(menuTree: Menu[]): Menu[] {
    return menuTree.map(menu => {
        let listComp;
        // 根据 realm 最末段匹配对应的组件（兼容 /admin/user 这类）
        // 兼容后端可能提供 realm 或 realmUrl 两种字段
        const primaryKey = getRealmKey(menu.realmUrl || (menu as any).realm);
        const realmKey = getRealmKey((menu as any).realm);
        const preferRealmKeys = new Set<string>(['schedule']);
        const key = realmKey && preferRealmKeys.has(realmKey) ? realmKey : primaryKey;
        switch (key) {
            case 'dept':
                listComp = Dept.list;
                break;
            case 'user':
                listComp = User.list;
                break;
            case 'menu':
                listComp = MenuComp.list;
                break;
            case 'role':
                listComp = Role.list;
                break;

            // dictionary module menu
            case 'hk-frs':
                listComp = SmeFrs.list;
                break;
            
            case 'work-done':
            case 'objectives': // legacy last-segment alias
                listComp = WokeDone.list;
                break;  

            case 'bank':
                listComp = Bank.list;
                break;

            case 'audit-certificate':
                listComp = AuditCertificate.list;
                break;

            case 'tax-rep':
                listComp = TaxRep.list;
                break;

            // account module pages
            case 'company':
                listComp = Company.list;
                break;
            case 'company-annual':
                listComp = CompanyAnnual.list;
                break;
            case 'gl-category':
                listComp = GlCategory.glList;
                break;
            case 'fs-category':
                listComp = GlCategory.fsList;
                break;
            case 'company-fs-category':
                listComp = companyFsCategory.list;
                break;
            case 'company-gl-category':
                listComp = companyGlCategory.list;
                break;
            case 'gl-invoice':
                listComp = GlInvoice.list;
                break;

            // monitor
            case 'service-monitor':
                listComp = ServiceMonitor;
                break;

            // gov-manage module
            case 'c7':
                listComp = GovC7.list;
                break;
            case 'program-template':
                listComp = GovProgramTemplate.list;
                break;
            case 'ird-rate':
                listComp = GovIrdRate.list;
                break;

            // tools module
            case 'currency-rate':
                listComp = ToolsCurrencyRate.list;
                break;
            case 'ocr-config':
                listComp = OcrConfig;
                break;
            case 'operation-log':
                listComp = OperationLog.list;
                break;

            // audit module menu
            case 'fs-status':
                listComp = financeStatement.list;
                break;
            case 'schedule':
                listComp = adjustment.list;
                break;
            default:
                break;
        }
        // 递归处理子菜单
        const children = menu.children ? attachComponent(menu.children) : [];

        // if (!listComp && (!children || children.length === 0) && process.env.NODE_ENV !== 'production') {
        //     // eslint-disable-next-line no-console
        //     console.warn('[router.attachComponent] No list component mapped for menu:', {
        //         menuId: menu.menuId,
        //         menuName: menu.menuName,
        //         realm: (menu as any).realm,
        //         realmUrl: (menu as any).realmUrl,
        //         key,
        //     });
        // }
        return {
            ...menu,
            ...(listComp && { list: listComp }),
            children,
        };
    });
}